module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Email List")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getAllEmailDataMasterList('Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "justify-content-left"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v("Email List Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Email Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "email_name",
      "name": "email_name",
      "disabled": "",
      "placeholder": "Email Name"
    },
    model: {
      value: (_vm.EmailListMaster.email_name),
      callback: function($$v) {
        _vm.$set(_vm.EmailListMaster, "email_name", $$v)
      },
      expression: "EmailListMaster.email_name"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Email TO "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "emaillist_to",
      "name": "emaillist_to",
      "placeholder": "Email TO"
    },
    on: {
      "input": function($event) {
        _vm.checkEmailID('emaillist_to')
      }
    },
    model: {
      value: (_vm.EmailListMaster.emaillist_to),
      callback: function($$v) {
        _vm.$set(_vm.EmailListMaster, "emaillist_to", $$v)
      },
      expression: "EmailListMaster.emaillist_to"
    }
  }), _vm._v(" "), (!_vm.EmailListMaster.emaillist_to || _vm.errorList.emaillist_to) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.emaillist_to))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Email CC")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emaillist_cc",
      "name": "emaillist_cc",
      "placeholder": "Email CC"
    },
    on: {
      "input": function($event) {
        _vm.checkEmailID('emaillist_cc')
      }
    },
    model: {
      value: (_vm.EmailListMaster.emaillist_cc),
      callback: function($$v) {
        _vm.$set(_vm.EmailListMaster, "emaillist_cc", $$v)
      },
      expression: "EmailListMaster.emaillist_cc"
    }
  }), _vm._v(" "), (_vm.errorList.emaillist_cc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.emaillist_cc))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Email BCC")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emaillist_bcc",
      "name": "emaillist_bcc",
      "placeholder": "Email BCC"
    },
    on: {
      "input": function($event) {
        _vm.checkEmailID('emaillist_bcc')
      }
    },
    model: {
      value: (_vm.EmailListMaster.emaillist_bcc),
      callback: function($$v) {
        _vm.$set(_vm.EmailListMaster, "emaillist_bcc", $$v)
      },
      expression: "EmailListMaster.emaillist_bcc"
    }
  }), _vm._v(" "), (_vm.errorList.emaillist_bcc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.emaillist_bcc))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Select Branches")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.branchListOptions,
      "selected-options": _vm.branch_items,
      "placeholder": "Select Branches",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultiBranch
    },
    model: {
      value: (_vm.selectedBranches),
      callback: function($$v) {
        _vm.selectedBranches = $$v
      },
      expression: "selectedBranches"
    }
  }), _vm._v(" "), (_vm.branchListOptions.length === 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("No branches available")])]) : _vm._e()], 1), _vm._v(" "), (_vm.branch_items && _vm.branch_items.length > 0) ? _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "12"
    }
  }, [_c('h6', [_vm._v("Branch Email Configuration")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Branch Name")]), _vm._v(" "), _c('th', [_vm._v("Email TO")]), _vm._v(" "), _c('th', [_vm._v("Email CC")]), _vm._v(" "), _c('th', [_vm._v("Email BCC")]), _vm._v(" "), _c('th', [_vm._v("Export")]), _vm._v(" "), _c('th', [_vm._v("Import")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.branchEmailTableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('span', [_vm._v(_vm._s(item.branch_name))])]), _vm._v(" "), _c('td', [_c('b-textarea', {
      attrs: {
        "placeholder": "Email TO",
        "rows": "2"
      },
      on: {
        "input": function($event) {
          _vm.validateBranchEmail(item, 'emails_to')
        }
      },
      model: {
        value: (item.emails_to),
        callback: function($$v) {
          _vm.$set(item, "emails_to", $$v)
        },
        expression: "item.emails_to"
      }
    }), _vm._v(" "), (item.errors && item.errors.emails_to) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.errors.emails_to))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-textarea', {
      attrs: {
        "placeholder": "Email CC",
        "rows": "2"
      },
      on: {
        "input": function($event) {
          _vm.validateBranchEmail(item, 'emails_cc')
        }
      },
      model: {
        value: (item.emails_cc),
        callback: function($$v) {
          _vm.$set(item, "emails_cc", $$v)
        },
        expression: "item.emails_cc"
      }
    }), _vm._v(" "), (item.errors && item.errors.emails_cc) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.errors.emails_cc))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-textarea', {
      attrs: {
        "placeholder": "Email BCC",
        "rows": "2"
      },
      on: {
        "input": function($event) {
          _vm.validateBranchEmail(item, 'emails_bcc')
        }
      },
      model: {
        value: (item.emails_bcc),
        callback: function($$v) {
          _vm.$set(item, "emails_bcc", $$v)
        },
        expression: "item.emails_bcc"
      }
    }), _vm._v(" "), (item.errors && item.errors.emails_bcc) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.errors.emails_bcc))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-checkbox', {
      attrs: {
        "value": 1,
        "unchecked-value": 0
      },
      model: {
        value: (item.is_export),
        callback: function($$v) {
          _vm.$set(item, "is_export", $$v)
        },
        expression: "item.is_export"
      }
    }, [_vm._v("\n                            Export\n                          ")])], 1), _vm._v(" "), _c('td', [_c('b-form-checkbox', {
      attrs: {
        "value": 1,
        "unchecked-value": 0
      },
      model: {
        value: (item.is_import),
        callback: function($$v) {
          _vm.$set(item, "is_import", $$v)
        },
        expression: "item.is_import"
      }
    }, [_vm._v("\n                            Import\n                          ")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addEmailListMaster
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Module Master"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }, _vm.SelectAll]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2"
  }, [_vm._v("Select / Deselect All Count (" + _vm._s(_vm.selectedEmailIds.length) + ")")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Email_List_data,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "id_email_section",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "id_email_section",
      fn: function(row0) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.selectedEmailIds),
            expression: "selectedEmailIds"
          }],
          attrs: {
            "type": "checkbox",
            "id": 'email_' + row0.item.id_email_section
          },
          domProps: {
            "value": row0.item.id_email_section,
            "checked": Array.isArray(_vm.selectedEmailIds) ? _vm._i(_vm.selectedEmailIds, row0.item.id_email_section) > -1 : (_vm.selectedEmailIds)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.selectedEmailIds,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.id_email_section,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectedEmailIds = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.selectedEmailIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selectedEmailIds = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "ml-2"
        }, [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "email_name",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.email_name != "" ? row1.item.email_name : "--"))])]
      }
    }, {
      key: "emaillist_to",
      fn: function(row2) {
        return [(row2.item.emaillist_to && row2.item.emaillist_to !== '') ? _c('span', [_vm._l((row2.item.emaillist_to.split(',')), function(item1, index) {
          return [(item1.trim() !== '') ? _c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1))])], 1) : _vm._e()]
        })], 2) : _vm._e()]
      }
    }, {
      key: "emaillist_cc",
      fn: function(row3) {
        return [(row3.item.emaillist_cc && row3.item.emaillist_cc !== '') ? _c('span', [_vm._l((row3.item.emaillist_cc.split(',')), function(item2, index) {
          return [(item2.trim() !== '') ? _c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2))])], 1) : _vm._e()]
        })], 2) : _vm._e()]
      }
    }, {
      key: "emaillist_bcc",
      fn: function(row4) {
        return [(row4.item.emaillist_bcc && row4.item.emaillist_bcc !== '') ? _c('span', [_vm._l((row4.item.emaillist_bcc.split(',')), function(item3, index) {
          return [(item3.trim() !== '') ? _c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3))])], 1) : _vm._e()]
        })], 2) : _vm._e()]
      }
    }, {
      key: "is_active_email",
      fn: function(row5) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row5.item.id_email_section
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row5.item.id_email_section,
            "name": "approval",
            "value": row5.item.is_active_email == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateEmailSection(row5.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row5.item.is_active_email == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row5.item.id_email_section
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row5.item.is_active_email == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "username",
      fn: function(row22) {
        return [(row22.item.username != null || row22.item.updation_time != null) ? _c('div', [_c('span', [_c('b', [_vm._v("Update By: ")]), _vm._v(_vm._s(row22.item.username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Updation Time: ")]), _vm._v(_vm._s(row22.item.updation_time))])]) : _vm._e()]
      }
    }, {
      key: "action",
      fn: function(row5) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editEmailListDashborad(row5.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c71f2862","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/email-section.vue
// module id = 2857
// module chunks = 0